"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemsCounterSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Renders Skeleton for `ItemsCounter`.
 */
const ItemsCounterSkeleton = ({
  animation = 'pulse',
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.ITEMS_COUNTER_SKELETON),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      variant: "rectangular",
      width: "100px",
      height: "22px",
      animation: animation
    })
  });
};
exports.ItemsCounterSkeleton = ItemsCounterSkeleton;
